import { render } from "./CxSurfaceLogOverlayControls.vue?vue&type=template&id=3813ae00"
import script from "./CxSurfaceLogOverlayControls.vue?vue&type=script&lang=js"
export * from "./CxSurfaceLogOverlayControls.vue?vue&type=script&lang=js"

import "./CxSurfaceLogOverlayControls.vue?vue&type=style&index=0&id=3813ae00&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__